(function(){
  'use strict';
  var KEY='bt-inf-state';
  document.documentElement.classList.add('bt-inf-js');
  function sectionIdOf(el){var s=el.closest('[id^="shopify-section-"]');return s?s.id.replace('shopify-section-',''):null}
  function withParam(url,k,v){return url+(url.indexOf('?')>-1?'&':'?')+k+'='+encodeURIComponent(v)}
  function setText(inf,txt,busy){var t=inf.querySelector('[data-bt-inf-text]');if(t)t.textContent=txt;inf.classList.toggle('is-busy',!!busy);inf.classList.toggle('has-text',!!txt)}
  function finish(inf){var total=inf.getAttribute('data-total');inf.setAttribute('data-next','');setText(inf,total&&+total>0?'All '+total+' shown':'',false);inf.classList.add('is-done')}
  function loadNext(inf,grid,sid){
    if(inf._loading)return Promise.resolve(false);
    var next=inf.getAttribute('data-next');if(!next){finish(inf);return Promise.resolve(false)}
    inf._loading=true;setText(inf,'Loading more tyres',true);
    return fetch(withParam(next,'section_id',sid),{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var ng=doc.getElementById('product-grid');
      if(ng){var frag=document.createDocumentFragment();Array.prototype.slice.call(ng.children).forEach(function(li){frag.appendChild(document.importNode(li,true))});grid.appendChild(frag)}
      var ni=doc.querySelector('[data-bt-inf]');
      var nn=ni?ni.getAttribute('data-next'):'';var np=ni?ni.getAttribute('data-page'):null;
      inf.setAttribute('data-next',nn||'');if(np)inf.setAttribute('data-page',np);
      var a=inf.querySelector('.bt-inf__next');if(a){if(nn)a.setAttribute('href',nn);else a.remove()}
      inf._loading=false;
      if(!nn)finish(inf);else setText(inf,'',false);
      return true;
    }).catch(function(){inf._loading=false;setText(inf,'Could not load more. Scroll to try again.',false);return false});
  }
  function init(){
    document.querySelectorAll('[data-bt-inf]').forEach(function(inf){
      if(inf._bt)return;inf._bt=true;
      var sec=inf.closest('[id^="shopify-section-"]')||document;
      var grid=sec.querySelector('#product-grid');var sid=sectionIdOf(inf);
      if(!grid||!sid)return;
      if(!inf.getAttribute('data-next')){finish(inf);return}
      var io=new IntersectionObserver(function(es){if(es[0].isIntersecting){loadNext(inf,grid,sid).then(function(ok){if(ok){io.unobserve(inf);io.observe(inf)}})}},{rootMargin:'900px 0px'});
      io.observe(inf);
      /* back button: restore how far the shopper had scrolled */
      grid.addEventListener('click',function(e){var a=e.target.closest('a[href]');if(!a)return;try{sessionStorage.setItem(KEY,JSON.stringify({u:location.href,p:+inf.getAttribute('data-page'),y:window.scrollY}))}catch(err){}});
      var nav=(performance.getEntriesByType&&performance.getEntriesByType('navigation')[0])||{};
      if(nav.type==='back_forward'){var st=null;try{st=JSON.parse(sessionStorage.getItem(KEY)||'null')}catch(err){}
        if(st&&st.u===location.href&&st.p>1){var go=function(){if(+inf.getAttribute('data-page')<st.p&&inf.getAttribute('data-next')){loadNext(inf,grid,sid).then(function(ok){if(ok)go();else window.scrollTo(0,st.y)})}else{window.scrollTo(0,st.y)}};go()}}
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  /* Dawn's filters re-render the grid: pick up the new sentinel */
  var mo=new MutationObserver(function(){clearTimeout(mo._t);mo._t=setTimeout(init,60)});
  function watch(){var c=document.getElementById('ProductGridContainer')||document.querySelector('.template-search__results')||document.querySelector('main');if(c)mo.observe(c,{childList:true,subtree:true})}
  if(document.readyState!=='loading')watch();else document.addEventListener('DOMContentLoaded',watch);
})();